import { SortFieldOption } from 'core/components/server-side-pagination/ServerSideSort'
import { VMFilterParams } from './useVMFilterConfigs'

export const defaultVMFilterParams: VMFilterParams = {
  cluster: 'all',
  vm_state: 'all',
  owner: 'all',
  flavor: 'all',
  image: 'all',
  host: 'all',
  tenant_id: '',
}

export enum IVirtualMachinesListPageTabs {
  VirtualMachinesList = 'list',
  ResourceUtilization = 'resource-utilization',
}

export enum VM_SEARCH_FIELDS_ENUM {
  NAME = 'name',
  UUID = 'uuid',
  IP = 'ip',
  IP6 = 'ip6',
  METADATA = 'metadata',
}

// Search field options for VMs
export const VM_SEARCH_FIELDS = [
  { value: VM_SEARCH_FIELDS_ENUM.NAME, label: 'Name' },
  { value: VM_SEARCH_FIELDS_ENUM.UUID, label: 'UUID' },
  { value: VM_SEARCH_FIELDS_ENUM.IP, label: 'IPv4 Address' },
  { value: VM_SEARCH_FIELDS_ENUM.IP6, label: 'IPv6 Address' },
  { value: VM_SEARCH_FIELDS_ENUM.METADATA, label: 'Metadata' },
]

// Sort field options for VMs
export const VM_SORT_OPTIONS: SortFieldOption[] = [
  { value: 'created_at', label: 'Created At' },
  { value: 'display_name', label: 'Name' },
  { value: 'uuid', label: 'UUID' },
  { value: 'vm_state', label: 'State' },
  { value: 'cluster', label: 'Cluster' },
  { value: 'owner', label: 'Owner' },
  { value: 'host', label: 'Host' },
  { value: 'instance_type_id', label: 'Flavor' },
  { value: 'tenant_id', label: 'Tenant' },
  { value: 'image_ref', label: 'Source Image' },
  { value: 'updated_at', label: 'Updated At' },
  { value: 'launched_at', label: 'Launched At' },
  { value: 'terminated_at', label: 'Terminated At' },
]
